import { SagaIterator } from '@redux-saga/core';
import { takeEvery } from 'redux-saga/effects';
import { workerSendMassCreativeAddTask, workerSendToGridSaga, workerUpdateDspSaga } from './workers';
import { fetchSendCreoToGrid, fetchSendMassCreativeAddTask, fetchUploadDsp } from '../reducer';

export default function* watchSideMenu(): SagaIterator {
  yield takeEvery(fetchUploadDsp, workerUpdateDspSaga);
  yield takeEvery(fetchSendCreoToGrid, workerSendToGridSaga);
  yield takeEvery(fetchSendMassCreativeAddTask, workerSendMassCreativeAddTask);
}
